import { con } from '../constants/advertiser'
import { useContext, useRef } from 'react'
import classNames from 'classnames'
import ImageWithBasePath from '../components/ImageWithBasePath'
import { OpenPlayStore } from '../components/OpenPlayStore'
import { capitalizeFirstLetter } from '../utils/functions'
import useTranslation from '../hooks/useTranslation'
import { NextLink } from './NextLink'
import { SharedContext } from '@/context/SharedContext'

const FooterSubSection = ({
  title = '',
  id,
  list = [],
  isViewAllPresent = true,
  onClick,
  itemKey = 'title',
  viewAllText = '',
  viewAllOnClick
}) => {
  return (
    <div className="space-y-[16px]">
      <h2 className="mb-[0px] text-lg font-bold leading-[30.7px] tracking-[0.5px] text-[#8B8B8B] md:text-base md:leading-[21.56px]">
        {title}
      </h2>
      <div className="space-y-[16px]">
        {list?.map((item, index) => {
          return (
            <div key={index}>
              <NextLink
                id={item?.[itemKey] + '_footer_' + index}
                href={'/advertiserPostJob'}
                as={'/hire/post-job'}
                isLoader={false}
                onClick={item?.onClick || (() => onClick(id, item?.id))}
              >
                <div
                  className=" w-fit cursor-pointer text-base font-normal leading-[21.56px] tracking-[0.5px] text-[#E0E0E0]"
                  key={index}
                >
                  {capitalizeFirstLetter(item?.[itemKey])}
                </div>
              </NextLink>
            </div>
          )
        })}
      </div>
      {isViewAllPresent && (
        <NextLink
          id={title}
          isLoader={false}
          href={{ pathname: '/sitemap', query: { elementTitle: title } }}
          as="/jobs/sitemap"
          className="mt-[1.31px] flex cursor-pointer items-center"
          onClick={viewAllOnClick}
        >
          <div className="text-base font-normal leading-[21.56px] tracking-[0.5px] text-[#FFBB00]">
            {viewAllText}
          </div>
          <div className="relative h-[24px] w-[24px]">
            <ImageWithBasePath src="view_all_arrow" fill alt="view all button arrow" />
          </div>
        </NextLink>
      )}
    </div>
  )
}

const CustomerSection = ({ title = '', list = [], openPath }) => {
  return (
    <div className="space-y-[16px] md:hidden">
      <div className="text-md font-normal leading-[24.64px] tracking-[0.5px] text-white">
        {title}
      </div>
      <div className="space-y-[16px]">
        {list?.map((item, index) => {
          return (
            <div
              key={index}
              className=" text-md font-normal leading-[24.64px] tracking-[0.5px] text-white"
              onClick={() => openPath(item?.path)}
            >
              {item?.title}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export const HomePageFooter = ({
  navigateToJobListingFromAdvertiser,
  navigateToPostJob,
  navigateToLogin,
  footerCategories,
  footerLocations,
  isLogin,
  navigateToListing,
  isAdvertiser = false,
  navigateToSiteMap
}) => {
  const translation = useTranslation()
  const { cookie } = useContext(SharedContext)

  const customerSection = [
    {
      title: translation.footerFields.emailUs,
      path: 'mailto:support@getlokalapp.com'
    },
    {
      title: translation.footerFields.privacyPolicy,
      path: 'https://getlokalapp.com/?page_id=3'
    },
    {
      title: translation.footerFields.termsAndConditions,
      path: 'https://getlokalapp.com/termsofcontent/'
    }
  ]

  const quickLinks = [
    { title: translation?.postAJob, onClick: navigateToPostJob },
    {
      title: translation?.findAJob,
      onClick: !isAdvertiser
        ? navigateToJobListingFromAdvertiser
        : () => {
            return navigateToListing('noBody')
          }
    }
  ]

  if (!isLogin)
    quickLinks.push({
      title: translation.createAnAccount,
      onClick: navigateToLogin
    })

  const openPath = (path) => {
    window?.open(path)
    return true
  }

  const categoryAndLocationOnclick = (key, value) => {
    if (!isAdvertiser) {
      // setFormData((prv) => ({ ...prv, [key]: value }))
      return navigateToPostJob()
    } else {
      return navigateToListing(key, value)
    }
  }

  return (
    <div
      className="space-y-[24px] bg-[#262626] py-[48px] px-[24px] font-noto-sans md:flex md:justify-between md:space-y-[0px] md:py-[56px] md:px-[85px]"
      id="quick_access_footer_container"
    >
      <div className="space-y-[24px] pr-[54px] md:w-[394.11px] md:pr-[0px]">
        <div className="relative h-[22px] w-[115px]">
          <ImageWithBasePath src="advertiser_footer_logo" fill alt="recruiter footer logo" />
        </div>
        <div className="w-[258px] text-base font-normal leading-[23px] text-[#F2F2F2] md:w-[394.11px]">
          With 40M+ downloads, Lokal is a one stop solution for local updates, job search,
          classifieds and more!
        </div>

        <OpenPlayStore {...{ translation: con, isHeaderPresent: false }} />
      </div>
      <CustomerSection title="Customer Services" list={customerSection} {...{ openPath }} />
      <FooterSubSection
        id="quick_links"
        title="Quick Links"
        list={quickLinks}
        isViewAllPresent={false}
      />
      <FooterSubSection
        id="job_category"
        title="Jobs by category"
        list={footerCategories}
        onClick={categoryAndLocationOnclick}
        itemKey={'english_name'}
        viewAllText="View all categories"
        viewAllOnClick={
          isAdvertiser
            ? () => navigateToSiteMap('Jobs by category')
            : () => {
                return true
              }
        }
      />
      <FooterSubSection
        id="constituency"
        title="Jobs by location"
        list={footerLocations}
        onClick={(id, itemId) => {
          if (!isAdvertiser) {
            // cookie.set('userState', itemId != undefined ? itemId : '', { path: '/' })
            return navigateToPostJob()
          } else return navigateToListing('location', itemId)
        }}
        itemKey={'short_name'}
        viewAllText="View all locations"
        viewAllOnClick={
          isAdvertiser
            ? () => navigateToSiteMap('Jobs by location')
            : () => {
                return true
              }
        }
      />
    </div>
  )
}

export const CustomerServices = () => {
  const translation = useTranslation()
  const date = useRef([
    {
      title: translation.footerFields.emailUs,
      path: 'mailto:jobssupport@getlokalapp.com'
    },
    {
      title: translation.footerFields.privacyPolicy,
      path: 'https://getlokalapp.com/?page_id=3'
    },
    {
      title: translation.footerFields.termsAndConditions,
      path: 'https://getlokalapp.com/termsofcontent/'
    },
    { title: '© 2000 Lokal' }
  ])

  const service = useRef({ mobile: '+912047170323', email: 'jobssupport@getlokalapp.com' })

  const openPath = (path) => {
    window?.open(path)
  }

  return (
    <div className="flex h-[76px] flex-col justify-between py-[16px] px-[24px] md:h-[92px] md:flex-row md:items-center md:px-[80px] md:py-[0px]">
      <div
        className={classNames(
          'flex flex-1 justify-between font-noto-sans text-sm font-normal leading-[16.34px] text-[#666666] md:justify-start md:space-x-[40px]'
        )}
      >
        {date?.current?.map((item, index) => {
          return (
            <div
              className={item?.path && 'w-fit cursor-pointer'}
              key={index}
              onClick={() => item?.path && openPath(item?.path)}
            >
              {item?.title}
            </div>
          )
        })}
      </div>
      <div className="flex justify-between md:space-x-[32px]">
        {/* <div className="flex items-center space-x-[8px]">
          <div className="relative h-[16px] w-[16px]">
            <ImageWithBasePath src="customer_call" fill alt="call symbol" />
          </div>
          <div className="cursor-pointer font-noto-sans text-sm font-normal leading-[16.34px] text-[#666666]">
            {service?.current?.mobile}
          </div>
        </div> */}
        <div className="flex items-center space-x-[8px]">
          <div className="relative h-[16px] w-[16px]">
            <ImageWithBasePath src="customer_email" fill alt="email symbol" />
          </div>
          <div className="cursor-pointer font-noto-sans text-sm font-normal leading-[16.34px] text-[#666666]">
            {service?.current?.email}
          </div>
        </div>
      </div>
    </div>
  )
}
